const initState = {
  loading: false,
  user: "There",
  isAuthenticated: false,
  theme: "light",
};

const generalReducers = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "loading":
      return { ...state, loading: payload };
    case "user":
      return { ...state, user: payload };
    case "auth":
      return { ...state, isAuthenticated: payload };
    case "SET_SIGNATURE":
      return { ...state, is_signature: payload };
    case "theme":
      return { ...state, theme: payload };
    case "logout":
      return initState;
    default:
      return state;
  }
};

export default generalReducers;
